export { getStaticPaths, default as getStaticProps } from "src/templates/blogs/[page]/getStaticProps";

export { default } from "src/templates/blogs/[page]/PageComponent";
